import { createApp } from "vue";
import importExcelDialog from "./importExcelDialog.vue";
import aiDropUpload from "./aiDropUpload.vue";

export function showMyDialog(options = {}, showCpn = 'importExcelDialog') {
  const container = document.createElement('div');
  document.body.appendChild(container);
  const cpn = { importExcelDialog, aiDropUpload }
  const app = createApp(cpn[showCpn], {
    visible: true,
    title: options.title,
    ...options,
    onCancel: () => {
      options.onCancel?.();
      destroy();
    },
    onFileSelected: (file) => options.onFileSelected?.(file)
  });

  app.mount(container);

  const destroy = () => {
    app.unmount();
    container.remove();
  };

  return { destroy };
}
